import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { realities, situations } from '../data/content';
export function Problem() {
  return <section className="w-full bg-navy px-4 py-14 text-white sm:py-20" data-id="element-196" data-mp="2bfptgctp2kqj">
      <div className="mx-auto w-full max-w-2xl" data-id="element-197" data-mp="2bffzke5j3tfk">
        <h2 className="text-center font-display text-[1.65rem] font-bold leading-tight sm:text-4xl" data-id="element-198" data-mp="2ge14gqvq71ac">
          Si alguna vez te ha pasado esto…
        </h2>
        <p className="mt-4 text-center text-[15px] leading-relaxed text-white/70 sm:text-lg" data-id="element-199" data-mp="21ntmec9mrka6">
          Ruta Clínica de Menopausia™ fue creada para ti.
        </p>

        <ul className="mt-8 space-y-3" data-id="element-200" data-mp="1sqj6gdlvb6yx">
          {situations.map((s, i) => <motion.li key={s.text} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.35,
          delay: i % 3 * 0.05
        }} className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.06] px-4 py-4 text-sm leading-snug text-white/85 sm:text-base" data-id="element-201" data-mp="1wq1uvjcwe06i" data-mpi={i}>
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-202" data-mp="oakjyxxprn62">
                {s.emoji}
              </span>
              {s.text}
            </motion.li>)}
        </ul>

        <p className="mt-9 text-center font-display text-xl italic text-gold-light sm:text-2xl" data-id="element-203" data-mp="xc1yibvh3gsn">
          Y la realidad es que…
        </p>

        <ul className="mt-4 space-y-2" data-id="element-204" data-mp="5kmacde9pm0b">
          {realities.map(r => <li key={r} className="rounded-xl bg-white/[0.05] px-4 py-3 text-center text-sm text-white/80 sm:text-base" data-id="element-205" data-mp="5ijaz2r86gix">
              {r}
            </li>)}
        </ul>

        <div className="mt-8 rounded-2xl border border-gold/40 bg-navy-deep p-6 text-center" data-id="element-206" data-mp="3n0knc7c98bgr">
          <p className="text-[15px] leading-relaxed text-white/80 sm:text-lg" data-id="element-207" data-mp="3i1rc6lkfwwjr">
            Porque cuando existe un sistema, las decisiones dejan de depender de la memoria.
            <span className="mt-1 block font-semibold text-gold-light" data-id="element-208" data-mp="1lwii0rb63nb1">
              Empiezan a depender de un proceso.
            </span>
          </p>
        </div>

        <div className="mt-9" data-id="element-209" data-mp="1vpqwlwrpll0c">
          <CTAButton label="Quiero dejar de improvisar" note="Garantía de 7 días · Sin riesgo" data-id="element-210" data-mp="1vqis77lb3iqm" />
        </div>
      </div>
    </section>;
}